import { FracFleetAvailabilityBase } from './base/frac-fleet-availability-base';

export class FracFleetAvailability extends FracFleetAvailabilityBase { }